import { Box, Typography } from "@mui/material";

import { formatSeconds } from "@/utils";

export default function TimeRow({ currentTime, duration }) {
  return (
    <Box
      id="time-row"
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        marginTop: "-10px",
      }}
    >
      <Typography variant="caption" color="textSecondary">
        {formatSeconds(currentTime)}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        - {formatSeconds(duration - currentTime)}
      </Typography>
    </Box>
  );
}
